import React, { FunctionComponent } from "react";
import styles from "./card.module.scss";
import Container from "./../Common/Container.tsx";

interface Props {
  align?: string;
  layout?: string;
  columnstart?: number;
  columnend?: number;
  rowstart?:number;
  rowend?:number;
  className?: string;
}

const CardHeader: FunctionComponent<Props> = (props) => {
  return (
    <Container
      align={props.align}
      layout={props.layout}
      columnstart={props.columnstart}
      columnend={props.columnend}
      className={`${styles.card_header} ${props.className}`}
      rowstart={props.rowstart}
      rowend={props.rowend}
    >
      {props.children}
    </Container>
  );
};

CardHeader.defaultProps = {
  align: "row",
  layout: "space_between_center",
};

export default CardHeader;
